import { Subject } from 'rxjs';
import WaveformData from 'waveform-data';

import { AudioEditor } from './AudioEditor';

export default class ViewBox {
  public from = 0;
  public to = 0;

  constructor(
    private readonly audioEditor: AudioEditor,
    private readonly waveformReadyToDrawSubject: Subject<WaveformData>,
    private readonly viewDraggedSubject: Subject<{ from: number; to: number }>,
  ) {
    this.audioEditor.onWaveformLoaded$.subscribe(waveform => {
      this.from = 0;
      this.to = waveform.duration;

      this.waveformReadyToDrawSubject.next(waveform);
    });

    this.audioEditor.onViewDragging$.subscribe(({ from, to }) => {
      this.from = from;
      this.to = to;
      this.viewDraggedSubject.next({ from, to });
    });
  }
}
